<template>
  <div class="container mt-5">
    <div class="row mb-5">
      <div class="col-8">
        <h3>Edit event</h3>
      </div>
      <div class="col-4 text-right">
        <button @click="$router.go(-1)" type="button" class="btn btn-secondary">Back</button>
      </div>
    </div>
    <div class="row" v-if="event">
      <div class="col-8 offset-2">
        <form @submit="submit">
          <div class="form-group">
            <label for="name">Event Name *</label>
            <input type="text" name="name" id="name" class="form-control" placeholder="ex: Competition Day 1" required v-model="form.name">
          </div>
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label for="date_start">Date Start *</label>
                <date-picker v-model="form.date_start" :config="options" required></date-picker>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="date_end">Date End</label>
                <date-picker v-model="form.date_end" :config="options"></date-picker>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="competition">Competition *</label>
                <select type="text" name="competition" id="competition" class="form-control" required  v-model="form.competition">
                  <option v-for="competition of competitions" :key="competition._id" :value="competition._id">{{competition.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="parent_event">Parent Event <small><i class="text-muted">Optional</i></small></label>
                <v-select v-model="form.parent_event" :options="events"></v-select>
                <small id="parentEventHelp" class="form-text text-muted">Only root events are shown here (events without parents)</small>
              </div>
            </div>
          </div>
          <hr>
          <button type="submit" class="btn btn-primary btn-lg">Edit</button>
        </form>
      </div>
    </div>
    <Loading v-if="!event"/>
  </div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { competitionService } from '../../services/competition'
import { eventService } from '../../services/event'
import vSelect from 'vue-select'
import moment from 'moment'
import clone from 'clone'

export default {
  name: 'EventEdit',
  components: { datePicker, vSelect },
  data () {
    return {
      date: new Date(),
      options: {
        format: 'YY-MM-DD HH:mm',
        useCurrent: false
      },
      competitions: [],
      events: [],
      event: null,
      form: {
        name: '', date_start: '', date_end: null, competition: '', parent_event: null
      },
      selected: null
    }
  },
  mounted () {
    eventService.getOne(this.$route.params.id).then(result => {
      this.event = result.data.event
      this.form = {
        name: this.event.name,
        date_start: new Date(this.event.date_start),
        date_end: this.event.date_end ? new Date(this.event.date_end) : null,
        competition: this.event.competition ? this.event.competition._id : null,
        parent_event: this.event.parent_event ? this.event.parent_event._id : null
      }
    })
    competitionService.getAll().then(result => {
      this.competitions = result.data.competitions
      if (this.$route.params.competitionid) {
        this.form.competition = this.$route.params.competitionid
      }
    })
    eventService.getAll().then(result => {
      for (let event of result.data.events) {
        this.events.push({label: event.name, value: event._id})
      }
      if (this.$route.params.parentid) {
        let foundEvent = result.data.events.filter(ev => ev._id === this.$route.params.parentid)[0]
        if (foundEvent) {
          this.form.parent_event = { label: foundEvent.name, value: foundEvent._id }
        }
      }
    })
  },
  methods: {
    submit (ev) {
      ev.preventDefault()
      let eventToSubmit = clone(this.form)
      eventToSubmit._id = this.event._id
      eventToSubmit.date_start = moment(eventToSubmit.date_start, 'YY-MM-DD HH:mm').valueOf()
      if (eventToSubmit.date_end) eventToSubmit.date_end = moment(eventToSubmit.date_end, 'YY-MM-DD HH:mm').valueOf()
      if (eventToSubmit.parent_event) eventToSubmit.parent_event = eventToSubmit.parent_event.value
      console.log(eventToSubmit)
      eventService.updateOne(eventToSubmit).then(res => {
        this.$router.push({ name: 'Event', params: { id: res._id } })
      })
    }
  }
}
</script>
<style lang="scss">
div.dropdown-toggle::after{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/Events/EventEdit.vue